import { useQueries } from '@tanstack/react-query';
import { useMemo } from 'react';
import { JiraIntegrationAPI } from '@/lib/api/work-integrations/jira';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetJiraItemTypeMappingsByInstanceIds = (instanceIds: string[]) => {
  const uniqueInstanceIds = useMemo(() => Array.from(new Set(instanceIds)).sort(), [instanceIds]);

  const results = useQueries({
    queries: uniqueInstanceIds.map((instanceId) => ({
      queryKey: workIntegrationsQueryKeys.jiraItemTypeMappings({ instanceId }),
      queryFn: () => JiraIntegrationAPI.getJiraItemTypeMappings({ instanceId }),
    })),
  });

  const isLoading = results.some((r) => r.isLoading);

  const mappedTypeIdsByInstanceId = useMemo(() => {
    const map = new Map<string, Set<number>>();
    uniqueInstanceIds.forEach((instanceId, index) => {
      const mappings = results[index]?.data ?? [];
      map.set(instanceId, new Set(mappings.map((m) => m.itemTypeId)));
    });
    return map;
  }, [uniqueInstanceIds, results]);

  return { mappedTypeIdsByInstanceId, isLoading };
};
